import { oneOf, readSearch, text } from '@/lib/search-params'

/**
 * Filtres de la vue « Relances », portés par l'URL. **Mes relances par défaut** :
 * c'est la question qu'on se pose en ouvrant l'écran le matin.
 */
const SHAPE = {
  /** `tous` pour lever le filtre ; absent veut dire « moi ». */
  personne: text(),
  etat: oneOf(['a-traiter', 'faites', 'toutes'] as const),
  /**
   * Les relances décidées, ou les clients dormants — ce que personne n'a
   * décidé. Deux mécanismes qui ne se remplacent pas, sur le même écran.
   */
  onglet: oneOf(['relances', 'dormants'] as const),
}

export interface RemindersSearch {
  personne?: string | undefined
  etat?: 'a-traiter' | 'faites' | 'toutes' | undefined
  onglet?: 'relances' | 'dormants' | undefined
}

export function parseRemindersSearch(search: Record<string, unknown>): RemindersSearch {
  return readSearch(SHAPE, search)
}

export const STATUS_BY_STATE = {
  'a-traiter': 'overdue,pending',
  faites: 'done',
  toutes: 'overdue,pending,done',
} as const
